import LooksCard from "@components/Cards/LooksCard"
import { Box } from "@components/Layout"
import { getKontentImage } from "@lib/kontent/getKontentImage"
import { LookDetailPage } from "@lib/kontent/models-deprecated/look_detail_page"
import { rem } from "polished"
import React from "react"
import styled from "styled-components"

const Grid = styled(Box)`
  display: grid;
`

interface Props {
  items: LookDetailPage[]
}

const LooksGrid: React.FC<Props> = ({ items }) => {
  return (
    <Grid
      mb={["4rem"]}
      gridTemplateColumns={["100%", "repeat(2, 1fr)"]}
      gridColumnGap={[0, "1rem", "1.5rem"]}
      gridRowGap={["1rem", "1rem", "1.5rem"]}
      gridAutoRows={[rem(360), rem(130), rem(200)]}
      data-testid="looks-grid"
    >
      {items.map((item, index) => {
        if (!item) {
          return null
        }

        const horizontalImg = getKontentImage(
          item.horizontalImage.value[0]?.url,
          {
            width: 700,
          }
        )
        const verticalImg = getKontentImage(item.verticalImage.value[0]?.url, {
          width: 700,
        })
        const isOdd = index % 2 === 0

        return (
          <Box
            key={index}
            gridRow={["auto", isOdd ? "span 2" : "span 3"]}
            position="relative"
          >
            <LooksCard
              image={isOdd ? horizontalImg : verticalImg}
              href={"/looks/[uid]"}
              as={`/looks/${item.urlSlug.value}`}
            >
              <></>
            </LooksCard>
          </Box>
        )
      })}
    </Grid>
  )
}

export default LooksGrid
